import { hc } from "hono/client";
import type { ApiCoordinacion } from "../worker/api";

/** Cliente RPC tipado punta a punta. `token()` devuelve el JWT de Supabase o null. */
export function crearApi(token: () => Promise<string | null>) {
  return hc<ApiCoordinacion>("/", {
    headers: async () => {
      const t = await token();
      const h: Record<string, string> = {};
      if (t) h.authorization = `Bearer ${t}`;
      return h;
    },
  });
}

export type Api = ReturnType<typeof crearApi>;

/** Convierte una respuesta de Hono en datos o lanza con el mensaje del servidor. */
export async function leer<T>(r: Response): Promise<T> {
  if (!r.ok) {
    let mensaje = `Error ${r.status}`;
    try {
      mensaje = ((await r.json()) as { error?: string }).error ?? mensaje;
    } catch {
      /* sin cuerpo */
    }
    throw new Error(mensaje);
  }
  return (await r.json()) as T;
}
